import { callApi } from './ApiClient';

const getResearchedTelHasDepartments = (data, dispatch) => {
  return callApi('GET', '/corporation_tel_researches/get_researched_tel_has_departments', data, dispatch);
}

export const CorporationTelResearchApi = {
  getResearchedTelHasDepartments,
};



// WEBPACK FOOTER //
// ./src/redux/api/CorporationTelResearchApi.js